import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LandingComponent } from './landing/landing.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import {
  TuiSvgModule,
  TuiTextfieldControllerModule,
  TuiHintModule,
} from '@taiga-ui/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TuiInputModule,
  TuiInputPasswordModule,
  TuiFieldErrorPipeModule,
} from '@taiga-ui/kit';

@NgModule({
  declarations: [LandingComponent, SignInComponent, PasswordResetComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    TuiSvgModule,
    FormsModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiInputPasswordModule,
    ReactiveFormsModule,
    TuiFieldErrorPipeModule,
    TuiHintModule,
  ],
})
export class AuthModule {}
